import styled from '@emotion/styled'

export const DiscountError = styled.div`
  position: absolute;
  bottom: 0;
`
